import logError from "lib/utils/errors/logError";
import { createAlert, render403, render404, pushRoute } from "modules/app/actions";
import { logout } from "modules/auth/actions";

export default function handleError(e, { getState, dispatch } = {}) {
  try {
    if (e && e.response) {
      if (e.response.status === 422) {
        return;
      }

      if (e.response.status === 401) {
        dispatch &&
          dispatch(
            createAlert({
              type: "error",
              uuid: "RESPONSE_401_ERROR",
              content: `Nie mogliśmy Cię zautoryzować podczas kontaktu z serwerem. Zaloguj się ponownie.`,
              timeout: false,
            })
          );
        dispatch && dispatch(logout());
        dispatch && dispatch(pushRoute("/login"));
        window.Raven &&
          Raven.captureException(e.toString(), {
            level: "info",
            extra: {
              response: e.response,
            },
          });
        return;
      }

      if (e.response.status === 403) {
        dispatch &&
          dispatch(
            createAlert({
              type: "error",
              uuid: "RESPONSE_403_ERROR",
              content: `Wystąpił błąd 403 podczas kontaktu z serwerem.`,
              timeout: false,
            })
          );
        dispatch && dispatch(render403());
        window.Raven &&
          Raven.captureException(e.toString(), {
            level: "info",
            extra: {
              response: e.response,
            },
          });
        return;
      }

      if (e.response.status === 404) {
        dispatch &&
          dispatch(
            createAlert({
              type: "error",
              uuid: "RESPONSE_404_ERROR",
              content: `Wystąpił błąd 404 podczas kontaktu z serwerem.`,
              timeout: false,
            })
          );
        dispatch && dispatch(render404());
        window.Raven &&
          Raven.captureException(e.toString(), {
            level: "info",
            extra: {
              response: e.response,
            },
          });
        return;
      }

      if (e.response.status === 409) {
        dispatch &&
          dispatch(
            createAlert({
              type: "error",
              uuid: "RESPONSE_409_ERROR",
              content: `Podczas zapisu na serwerze wykryliśmy, że nie pracujesz na bieżącej wersji rekordu. Spróbuj odświeżyć stronę i dokonać zmian ponownie.`,
              timeout: false,
            })
          );
        window.Raven &&
          Raven.captureException(e.toString(), {
            level: "info",
            extra: {
              response: e.response,
            },
          });
        return;
      }

      window.Raven &&
        Raven.captureException(e.toString(), {
          level: "warning",
          extra: {
            response: e.response,
          },
        });
    } else {
      if (__DEV__) {
        throw e;
      }

      logError(e);
    }
  } catch (e) {
    throw e;
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils/errors/handleError.js